import PropTypes from "prop-types";
import React, { Component } from "react";
import { MdDashboard, MdPendingActions, MdPayment, MdLeaderboard, MdViewModule } from "react-icons/md";
import { BiChevronRight, BiClinic } from "react-icons/bi";
import { FaUser, FaUserDoctor } from "react-icons/fa6";
import { FaClinicMedical, FaRegFileAlt } from "react-icons/fa";
//Simple bar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";

class SidebarContent extends Component {
  constructor(props) {
    super(props);
    this.refDiv = React.createRef();
  }

  componentDidMount() {
    this.initMenu();
  }

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState, ss) {
    if (this.props.type !== prevProps.type) {
      this.initMenu();
    }
  }

  initMenu() {
    new MetisMenu("#side-menu");

    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    for (let i = 0; i < items.length; ++i) {
      if (this.props.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      this.activateParentDropdown(matchingMenuItem);
    }
  }

  // componentDidUpdate() {}

  scrollElement = item => {
    setTimeout(() => {
      if (this.refDiv.current !== null) {
        if (item) {
          const currentPosition = item.offsetTop;
          if (currentPosition > window.innerHeight) {
            if (this.refDiv.current)
              this.refDiv.current.getScrollElement().scrollTop =
                currentPosition - 300;
          }
        }
      }
    }, 300);
  };

  activateParentDropdown = item => {
    item.classList.add("active");
    const parent = item.parentElement;

    const parent2El = parent.childNodes[1];
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      this.scrollElement(item);
      return false;
    }
    this.scrollElement(item);
    return false;
  };

  render() {
    return (
      <React.Fragment>
        <SimpleBar className="h-100" ref={this.refDiv}>
          <div id="sidebar-menu">
            <ul className="metismenu list-unstyled" id="side-menu">
              <li className="menu-title">{this.props.t("Menu")}</li>
              {localStorage.getItem('companyId') ?
                <li>
                  <Link to="/admin/dashboard">
                    {/* <i className="bx bx-home-circle" /> */}
                    <MdDashboard className='mb-1 me-1' size={20} />

                    <span className="ms-3">{this.props.t("Dashboard")}</span>
                  </Link>
                </li> :
                <li>
                  <Link to="/superadmin/dashboard">
                    {/* <i className="bx bx-home-circle" /> */}
                    <MdDashboard className='mb-1 me-1' size={20} />

                    <span className="ms-3">{this.props.t("Dashboard")}</span>
                  </Link>
                </li>
              }
              {localStorage.getItem('companyId') ?
                <li>
                  <Link to="/#" className="has-arrow">
                    <MdLeaderboard className='mb-1 me-1' size={20} />
                    <span className="ms-3">{this.props.t("Master")}</span>
                  </Link>
                  <ul className="sub-menu" aria-expanded="false">
                    <li className="ms-2">
                      <Link to="/admin/department-list">
                        {this.props.t("Department")}
                      </Link>
                    </li>
                    <li className="ms-2">
                      <Link to="/admin/designation-list">
                        {this.props.t("Designation")}
                      </Link>
                    </li>
                    <li className="ms-2">
                      <Link to="/admin/test-list">
                        {this.props.t("Test")}
                      </Link>
                    </li>

                  </ul>
                </li> :
                <li>
                  <Link to="/#" className="has-arrow">
                    <MdLeaderboard className='mb-1 me-1' size={20} />
                    <span className="ms-3">{this.props.t("Master")}</span>
                  </Link>
                  <ul className="sub-menu" aria-expanded="false">
                    <li className="ms-2">
                      <Link to="/superadmin/department-list">
                        {this.props.t("Department")}
                      </Link>
                    </li>
                    <li className="ms-2">
                      <Link to="/superadmin/designation-list">
                        {this.props.t("Designation")}
                      </Link>
                    </li>
                    

                  </ul>
                </li>}
              {localStorage.getItem('companyId') ? "" : <li>
                <Link to="/superadmin/pathology-list">
                  {/* <i className="bx bx-home-circle" /> */}
                  <FaClinicMedical  className='mb-1 me-1' size={20} />

                  <span className="ms-3">{this.props.t("Pathology")}</span>
                </Link>
              </li>}
              {localStorage.getItem('companyId') ? "" : <li>
                <Link to="/superadmin/module-list">
                  {/* <i className="bx bx-home-circle" /> */}
                  <MdViewModule   className='mb-1 me-1' size={20} />

                  <span className="ms-3">{this.props.t("Module")}</span>
                </Link>
              </li>}

              {localStorage.getItem('companyId') ? <li>
                <Link to="/admin/doctor-list">
                  {/* <i className="bx bx-home-circle" /> */}
                  <FaUserDoctor className='mb-1 me-1' size={20} />

                  <span className="ms-3">{this.props.t("Doctor")}</span>
                </Link>
              </li> : ""}
              {localStorage.getItem('companyId') ? <li>
                <Link to="/admin/patient-list">
                  {/* <i className="bx bx-home-circle" /> */}
                  <FaUser className='mb-1 me-1' size={20} />

                  <span className="ms-3">{this.props.t("Patient")}</span>
                </Link>
              </li> : ''}

              {localStorage.getItem('companyId') ?
               <li>
                <Link to="/admin/test-report">
                  {/* <i className="bx bx-home-circle" /> */}
                  <FaRegFileAlt className='mb-1 me-1' size={20} />

                  <span className="ms-3">{this.props.t("Test Report")}</span>
                </Link>
              </li> 
            //   <Link to="/admin/blood-test">       <li>
            //   {/* <Link to="/#" className="has-arrow"> */}
            //     <FaRegFileAlt className='mb-1 me-1' size={20} />
            //     <span className="ms-3">{this.props.t("Test Report")}</span>
            //   {/* </Link> */}
            //   {/* <ul className="sub-menu" aria-expanded="false">
            //     <li className="ms-2">
            //       <Link to="/admin/blood-test">
            //         {this.props.t("Microscope Test")}
            //       </Link>
            //     </li> 
            //   </ul> */}
            // </li></Link>
              : ''}
            </ul>
          </div>
        </SimpleBar>
      </React.Fragment>
    );
  }
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
  type: PropTypes.string,
};

export default withRouter(withTranslation()(SidebarContent));